import { useTranslation } from 'react-i18next';
import { Row, Col } from 'antd';
import redright from 'assets/images/redright.svg';
// import { useNavigate } from 'react-router-dom';
import { isLocaleEnglish } from 'utils/languageUtils';
import { useGetOptionAndPaymentPdf } from 'all-in-one-shared-api';
import { useEffect } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';

// import styled from 'styled-components';
interface propsdata {
  policyTypesObject: { label: string; label2: string; value: string }[];
}
export const PaymenttactCardno = (props: propsdata) => {
  const { t, i18n } = useTranslation();
  // const navigate = useNavigate();
  const isEnglish = isLocaleEnglish(i18n.language);
  const { token } = useKeycloakReady();

  const { shouldFetch, data: downUrl } = useGetOptionAndPaymentPdf('useGetOptionAndPaymentPdf', token || '');
  useEffect(() => {
    shouldFetch(true);
  }, [shouldFetch]);
  const downloadPdf = () => {
    if (isEnglish) {
      if (downUrl?.optionDownloadServiceFormEn) {
        const link = document.createElement('a');
        const url = downUrl?.optionDownloadServiceFormEn;
        link.href = url;
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.download = 'filename.pdf';
        document.body.appendChild(link);
        // link.click();
        const e = document.createEvent('MouseEvent');
        e.initEvent('click', false, false);
        link.dispatchEvent(e);
      }
    } else {
      if (downUrl?.optionDownloadServiceFormTc) {
        const link = document.createElement('a');
        const url = downUrl?.optionDownloadServiceFormTc;
        link.href = url;
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.download = 'filename.pdf';
        document.body.appendChild(link);
        // link.click();
        const e = document.createEvent('MouseEvent');
        e.initEvent('click', false, false);
        link.dispatchEvent(e);
      }
    }
  };
  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
      <Col xs={24} md={24}>
        <div
          style={{
            border: 'none',
            // color: "white",
            backgroundColor: 'transparent',
            fontSize: '20px',
            fontFamily: 'Roboto400',
            color: '#6F7072',
            borderBottom: '1px solid #CCCCCC',
            paddingBottom: '15px',
          }}
        >
          {props.policyTypesObject.length > 0
            ? t('life.MakeRequest.payment.Pleaseselecttext')
            : t('life.MakeRequest.payment.Pleaseselecttext2')}
        </div>
      </Col>
      <Col xs={24} md={24}>
        <div
          style={{
            border: 'none',
            // color: "white",
            backgroundColor: 'transparent',
            fontSize: '17px',
            fontFamily: 'Roboto400',
            color: '#6F7072',
          }}
        >
          {t('life.MakeRequest.contact.FooterText')}
        </div>
      </Col>
      <Col xs={24} md={24}>
        <div
          style={{
            border: 'none',
            // color: "white",
            backgroundColor: 'transparent',
            fontSize: '17px',
            fontFamily: 'Roboto500',
            color: '#C21B17',
            textAlign: 'center',
            marginTop: '24px',
          }}
        >
          <span onClick={downloadPdf} style={{ cursor: 'pointer' }}>
            {t('life.MakeRequest.contact.FooterButton')}
            <img src={redright} style={{ margin: '0  2px 0 10px', width: '8px', height: '14px' }} />
          </span>
        </div>
      </Col>
    </Row>
  );
};
